// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-coach-calib__wait {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
  text-align: center;
  color: #e2e8f0;
  font-size: 0.95rem;
  line-height: 1.4;
}

.lt-coach-calib .lt-eval-calib__preview {
  /* Still frame: show the whole picture so the coach can judge framing. */
  object-fit: contain;
  background: #020617;
}

/* Coach still-frame review uses the same transparent HUD chrome. */
.lt-coach-calib.lt-eval-calib {
  background: transparent;
}

.lt-coach-calib .lt-eval-calib__edge--right {
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingCoachCameraCalibration.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wEAAwE;EACxE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[".lt-coach-calib__wait {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 28px;\n  text-align: center;\n  color: #e2e8f0;\n  font-size: 0.95rem;\n  line-height: 1.4;\n}\n\n.lt-coach-calib .lt-eval-calib__preview {\n  /* Still frame: show the whole picture so the coach can judge framing. */\n  object-fit: contain;\n  background: #020617;\n}\n\n/* Coach still-frame review uses the same transparent HUD chrome. */\n.lt-coach-calib.lt-eval-calib {\n  background: transparent;\n}\n\n.lt-coach-calib .lt-eval-calib__edge--right {\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
